<script>
import VJsoneditor from "v-jsoneditor";
import Prompt from "../ai";
import api from "@/api";
import { mapActions, mapGetters } from "vuex";


export default {
  name: "BtnGenerator",
  props: {
    params: {
      type: Object,
      default: null
    },
    callback: {
      type: Function,
      default: undefined
    },
    promptName: {
      type: String,
      required: true
    },
    btnVariant: {
      type: String,
      default: "outline-dark"
    },
    btnText: {
      type: String,
      default: "Генерировать"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    listParams: {
      type: Array[Object],
      default: undefined
    },
    background: Boolean,
    bgItems: Object
  },
  components: { VJsoneditor },
  data() {
    return {
      prompt: Prompt[this.promptName],
      model: undefined,
      processing: false
    };
  },
  methods: {
    ...mapActions(["LOAD_AI_MODELS", "LOAD_AI_PROMPT_DEFAULTS"]),
    resetPrompt() {
      this.prompt.mapVars(this.params);
    },
    callGenerator() {
      this.processing = true;

      api.post(`/generator/from-prompt`, {
        promptAlias: this.promptName,
        messages: [
          {
            role: "system",
            content: this.prompt.messages.system
          },
          {
            role: "user",
            content: this.prompt.messages.user
          }
        ],
        model: this.model,
        params: this.prompt.params
      })
        .then(({ data }) => {
          if (this.callback ) {
            if (data) {
              this.callback(data);
            }
            else  {
              this.$bvToast.toast(`Сервис генерации вернул пустой ответ, попробуйте еще раз`, {
                ...this.commonToaster, variant: "warning"
              });
            }
          }
        })
        .catch((error) => {
          switch (error.response.status) {
            case 401:
              this.$bvToast.toast(`У вас недостаточно разрешений для вызова генерации тестов`, {
                ...this.commonToaster, variant: "danger"
              });
              break;
            case 422:
              if (error.response.data === "doc_not_specified") {
                this.$bvToast.toast(`Укажите идентификатор или название документа`, {
                  ...this.commonToaster, variant: "danger"
                });
                break;
              }
              this.$bvToast.toast(`Передано что-то невалидное`, {
                ...this.commonToaster, variant: "danger"
              });
              break;
            case 451:
              this.$bvToast.toast(`Сервис генерации недоступен`, {
                ...this.commonToaster, variant: "danger"
              });
              break;
            default:
              console.log(error);
              this.$bvToast.toast("Что-то пошло не так", {
                ...this.commonToaster, variant: "danger"
              });
              break;
          }
        })
        .finally(() => {
          this.processing = false;
        });
    },
    callBgGenerator() {
      this.processing = true;

      const items = {};

      for (const key in this.bgItems) {
        const messages = this.prompt.previewVars(this.bgItems[key]);
        items[key] = [
          {
            role: "system",
            content: messages.system
          },
          {
            role: "user",
            content: messages.user
          }
        ];
      }

      api.post(`/generator/from-prompt-bg`, {
        promptAlias: this.promptName,
        items,
        model: this.model,
        params: this.prompt.params
      })
        .then(({ data }) => {
          if (this.callback) {
            this.callback(data);
          }
        })
        .catch((error) => {
          switch (error.response.status) {
            case 401:
              this.$bvToast.toast(`У вас недостаточно разрешений для вызова генерации тестов`, {
                ...this.commonToaster, variant: "danger"
              });
              break;
            case 422:
              if (error.response.data === "doc_not_specified") {
                this.$bvToast.toast(`Укажите идентификатор или название документа`, {
                  ...this.commonToaster, variant: "danger"
                });
                break;
              }
              this.$bvToast.toast(`Передано что-то невалидное`, {
                ...this.commonToaster, variant: "danger"
              });
              break;
            case 451:
              this.$bvToast.toast(`Сервис генерации недоступен`, {
                ...this.commonToaster, variant: "danger"
              });
              break;
            default:
              console.log(error);
              this.$bvToast.toast("Что-то пошло не так", {
                ...this.commonToaster, variant: "danger"
              });
              break;
          }
        })
        .finally(() => {
          this.processing = false;
        });
    }
  },
  computed: {
    ...mapGetters(["HAS_PERMISSION", "AI_MODElS", "AI_PROMPT_DEFAULTS"]),
    notMapped() {
      const regex = /{\w+}/gm;

      let m;
      const notMapped = [];

      while ((m = regex.exec([this.prompt.messages.system, this.prompt.messages.user].join(" "))) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
          regex.lastIndex++;
        }

        m.forEach((match) => {
          if (!notMapped.includes(match)) {
            notMapped.push(match);
          }
        });
      }
      return notMapped;
    },
    modelColor() {
      return this.AI_MODElS?.reduce((acc, item) => {
        acc[item.code] = item.display_color;
        return acc;
      }, {}) ?? {};
    },
    elementId() {
      return `${this.promptName}-${new Date().getTime()}`;
    }
  },
  watch: {
    params: {
      handler() {
        this.prompt.mapVars(this.params);
      },
      deep: true
    },
    promptName() {
      this.model = this.AI_PROMPT_DEFAULTS[this.promptName];
      console.log(this.AI_PROMPT_DEFAULTS);
    },
    AI_PROMPT_DEFAULTS() {
      this.model = this.AI_PROMPT_DEFAULTS[this.promptName];
    }
  },
  mounted() {
    if (!this.AI_MODElS) {
      this.LOAD_AI_MODELS();
    }
    if (!this.AI_PROMPT_DEFAULTS) {
      this.LOAD_AI_PROMPT_DEFAULTS().then(() => {
        this.model = this.AI_PROMPT_DEFAULTS[this.promptName];
      });
    } else {
      this.model = this.AI_PROMPT_DEFAULTS[this.promptName];
    }
    this.prompt.mapVars(this.params);
  }
};
</script>

<template>
  <b-btn
    :id="elementId"
    :disabled="disabled || processing"
    :variant="btnVariant"
    @click="!background ? callGenerator() : callBgGenerator()"
  >
    {{ btnText }}
    <template v-if="!processing">
      <b-avatar :style="`background-color: ${modelColor[this.model]}`" icon="fa-microchip" size="0.5rem" />
      <template v-if="HAS_PERMISSION('generators_prompt')">
        <b-popover :target="elementId" custom-class="generator-popover" triggers="hover focus">
          <!--<template #title>Параметры генерации</template>-->
          <b-form-group label="Модель для генерации">
            <b-select v-model="model">
              <option v-for="model in AI_MODElS" :value="model.code">
                {{ model.name }} ({{ model.code }})
              </option>
            </b-select>
          </b-form-group>

          <b-form-group :label="`Температура ${prompt.params.temperature}`">
            <b-form-input
              v-model="prompt.params.temperature"
              max="1"
              min="0"
              number
              step="0.1"
              type="range"
            />
          </b-form-group>

          <b-btn @click="$refs['prompt-modal'].show()">
            Показать промпт
          </b-btn>
        </b-popover>
      </template>
    </template>
    <template v-else>
      <b-spinner label="processing..." small variant="primary" />
    </template>

    <b-modal
      ref="prompt-modal"
      cancel-title="Вернуть исходное"
      hide-header
      no-close-on-backdrop
      ok-title="Сохранить"
      size="xl"
      title="Промпт"
      @ok="$refs['prompt-modal'].hide()"
      @cancel.prevent="resetPrompt()"
    >
      <b-form-group label="Системный">
        <b-form-textarea v-model.trim="prompt.messages.system" rows="2" />
      </b-form-group>

      <b-form-group label="Пользовательский">
        <b-form-textarea v-model.trim="prompt.messages.user" rows="10" />
      </b-form-group>

      <template v-if="prompt?.params?.response_format?.json_schema">
        <b-button v-b-toggle.response-format variant="outline-dark">
          Формат ответа
        </b-button>
        <b-collapse id="response-format">
          <v-jsoneditor
            v-model="prompt.params.response_format.json_schema"
            :options="{
              mainMenuBar: true,
              statusBar: true,
              mode: 'code',
              language: 'ru',
              enableSort: false
            }"
            height="40vh"
          />
        </b-collapse>
      </template>

      <b-alert v-if="background" show variant="warning">
        <div>Переменные {{ notMapped.join(", ") }} будут взяты из каждого элемента списка.</div>
        <div>Вы должны оставить формат "{var}" при редактировании, если хотите чтобы меппинг состоялся</div>
      </b-alert>
    </b-modal>

  </b-btn>
</template>

<style scoped>
.badge-cyan {
  background-color: var(--cyan);
}

.badge-orange {
  background-color: var(--orange);
}

</style>

<style>
.generator-popover {
  z-index: 1060 !important;
}
</style>